@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.languages-icon {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}
.language-button {
  color: @authentication--language-button--text-color;
  svg {
    fill: @authentication--language-button--fill-color;
  }
}
